import { Component, Prop, Vue, Watch, Ref } from 'vue-property-decorator'
import EmergoRequest from '../models/emergo'
import EmergoService from '../services/emergo-service'

@Component
export default class EditTopic extends Vue {
  private model = new EmergoRequest(
    'spinne_kernbotschaften',
    'Info about other items in view',
    'Item 1',
    'Info for Item 1',
    'The clavis customer who will see this view',
    [],
    'informative'
  )

  private loading = false

  private async getResponse() {
    this.loading = true

    let result = (await EmergoService.sendAsync(this.model)) as EmergoRequest
    if (result) {
      this.model = result
      this.model['styleOptions'] = ['informative', 'reactive']
      this.model['tagOptions'] = ['kernbortschaft', 'item1', 'customer', 'view']
    }

    this.loading = false
  }
}
